import { ElemStats } from './activitymaps';

export function elemStatsIdent(stats: ElemStats): string {
  return elemIdent(stats.Selector, stats.PropertyValue);
}

export function elemIdent(selector: string, propertyValue: string | undefined): string {
  if (propertyValue === undefined) {
    return selector;
  }
  return `${selector}!!${propertyValue}`;
}
